var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../../_snowpack/pkg/react.js";

function SvgSolarPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.143 6.251h16.875a.75.75 0 100-1.5H2.143a.75.75 0 000 1.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.597h4.375v-3.75H8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.057 13.308H8.605A2.597 2.597 0 006 15.898v.153h9.662v-.153c0-1.43-1.166-2.59-2.605-2.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.151.25H3.338a.75.75 0 00-.728.57L.272 10.308a.75.75 0 00.728.93h19.49a.75.75 0 00.728-.93L18.879.821a.75.75 0 00-.728-.571zm-.587 1.5l1.968 7.986H1.957L3.926 1.75h13.638z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.605 10.548l.779-9.487A.75.75 0 007.889.94l-.78 9.486a.75.75 0 001.496.123zm6.493-.123l-.78-9.486a.75.75 0 10-1.494.122l.78 9.487a.75.75 0 001.494-.123z",
    fillRule: "nonzero"
  }))));
}

export default SvgSolarPanel;